"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "claut": {
    "635445bf": [{
      "hkey": "1125c164",
      "slug": "claut",
      "name": "Claut",
      "primary": true,
      "skipSearch": false
    }],
    "creppi": [{
      "hkey": "1125c164",
      "slug": "claut",
      "name": "Claut",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d0c0684b": [{
      "hkey": "1125c164",
      "slug": "claut",
      "name": "Claut",
      "primary": true,
      "skipSearch": false
    }],
    "lesis-stoc": [{
      "hkey": "1125c164",
      "slug": "claut",
      "name": "Claut",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "69c1ecef": [{
      "hkey": "1125c164",
      "slug": "claut",
      "name": "Claut",
      "primary": true,
      "skipSearch": false
    }],
    "matan": [{
      "hkey": "1125c164",
      "slug": "claut",
      "name": "Claut",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "56a78a39": [{
      "hkey": "1125c164",
      "slug": "claut",
      "name": "Claut",
      "primary": true,
      "skipSearch": false
    }],
    "vit": [{
      "hkey": "1125c164",
      "slug": "claut",
      "name": "Claut",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;